import { Component, ElementRef, forwardRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  DxTagBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';

@Component({
  selector: 'abc-tag-box',
  standalone: true,
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => _AbcTagBoxComponent),
    },
  ],
  template: '',
})
export class _AbcTagBoxComponent extends DxTagBoxComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.labelMode = 'floating';
  }
}
